export enum WorkspaceActionType {
  SetSpaceId = "SET_SPACE_ID",
}

export type InitialWorkspaceTypes = {
  spaceId: string;
};

export type WorkspaceStoreStateType = {
  spaceId: string;
};
